import React, { useEffect } from "react";
import "./header.min.css"
import { Link } from "react-router-dom";
import { TopNavigationMenu } from "./TopNavigationMenu";
import { MyAccountPanel } from "../MyAccountPanel";
import { redirectToAppNewsepickPage } from "../../../utils/Common";

function Header(props) {
  useEffect(() => {
    let $input =  window.$(".search_query");

    window.$('.search-toggle').on("click", function () {
        window.$(this).parent(".search_block_top1").addClass("active-search");
        window.$(".headerMain").addClass("searchact");
        $input.trigger("");
    });
    window.$('.search_block_top1').find('.search-close').on("click", function () {
        window.$('.topsearch').removeClass('active');
        window.$(".search_block_top1").removeClass("active-search");
        window.$(".headerMain").removeClass("searchact");
        $input.val('');
    });
    window.$(document).on('click', function (event) {
        if (!window.$(event.target).closest('.topsearch').length) {
            window.$('.topsearch').removeClass('active');
            window.$(".search_block_top1").removeClass("active-search");
            window.$(".headerMain").removeClass("searchact");
        }
    });
  }, []);

  const openMyAccountPanel = () => {
      document.body.classList.add('activeMyAccountPanelProf');
  };

  return (
    <header className="headerMain">
      <div className="container">
        <div className="row">
          <div className="col-3 col-sm-3 logo-box">
            <figure>
              <Link to="/">
                <img
                    src={"https://cdn.newsepick.com/logoBrand-r.png"}
                    alt="Newsepick"
                    className="img-fluid logo" />
                <img
                    src={"https://cdn.newsepick.com/mobile-logo.png"}
                    alt="Newsepick"
                    className="img-fluid mobilogo" />
              </Link>
            </figure>
          </div>
          <div className="col-9 col-sm-9 hRight">
            <div className="d-none d-lg-block">
                <TopNavigationMenu />
            </div>

            <div className="loginTop ms-1">
                <ul>
                    <li><a href={"javascript:void(0)"} onClick={() => redirectToAppNewsepickPage("login")}>Sign In</a></li>
                    <li><a href={"javascript:void(0)"} onClick={() => redirectToAppNewsepickPage("individual/signup")}>Sign Up</a></li>
                </ul>
            </div>

            <div className="myAccountTop">
                <div className="myAccountTopBtns">
                  <button type="button" id="menu-btn" className="menu-btn btn" onClick={() => {openMyAccountPanel();}}>
                      <span className="icon-bar"></span><span className="icon-bar"></span><span className="icon-bar"></span>
                  </button>
                </div>
                
                <MyAccountPanel />
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}

export { Header };
